import React from 'react';
import SMCPage from '../../components/core/pageComponents/SMCPage';
import SMCButton from '../../components/Simple/SMCButton';

class BodyErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    // componentDidCatch(error, errorInfo) {
    //     console.log(error, errorInfo);
    // }
    
    render() {
        if (this.state.hasError) {
            return (
                <SMCPage>
                    <div style={{ paddingBottom: '11px' }}>General Error</div>
                    <SMCButton onClick={() => window.location.href = '/'}>OK</SMCButton>
                </SMCPage>    
            )
        }
        else {
            return this.props.children;
        }
    }
}

export default BodyErrorBoundary;